export default "__VITE_ASSET__Dfuc9rxp__"